export enum ecarsoPhoneNumber {
    // Main numbers
    FREEPHONE_MAIN_AT = '+43800404061',
    FREEPHONE_MAIN_DE = '+498001480480',

    GEOGRAPHIC_MAIN_AT = '+4313580064',
}
